<template>
	<tr>
		<td>
			<strong class="show-for-medium-up" v-html="days"></strong>
      <span class="smaller show-for-small-only" v-html="dayWithTimes"></span>
		</td>

		<td class="">
			<div class="show-for-medium-up" v-html="times">
			</div>
			<div class="show-for-small-only">
<!--				<span class="smaller" v-html="times"-->
<!--					></span-->
<!--				><br />-->
				<span class="smaller"
					>{{ run.className }} ({{ ageFrom }} - {{ ageTo }})</span
				><br />
				<span class="smaller">
					<a href=""> {{ run.venueName }}</a>
				</span>

				<br />

				<a v-if="runHasTrialOptions" :href="viewRunInfoRoute">
					<span class="label success left mbs trial-label"
						>TRIAL</span
					>
				</a>
			</div>
		</td>
		<td class="show-for-medium-up">
			{{ run.venueName }}
		</td>
		<td class="show-for-medium-up">
			{{ run.className }} ({{ ageFrom }} - {{ ageTo }})
			<br />

			<a v-if="runHasTrialOptions" :href="viewRunInfoRoute">
				<span class="label success left mbs trial-label"
					>OFFERS TRIAL</span
				>
			</a>
		</td>

		<td class="" style="width: 20%">
			<a
				:class="{ info: hasNoSpacesAvailable, 'c4k-class-info-button': !hasNoSpacesAvailable, 'c4k-class-waiting-list-button': hasNoSpacesAvailable}"
				class="button radius small expand"
				:href="viewRunInfoRoute"
				data-test="infoAndBooking"
			>
				<i class="fa fa-info-circle hide-for-small"></i>
        <span class="hide-for-medium-up">
          {{ viewRegisterButtonTextMobile }}
        </span>
        <span class="show-for-medium-up">
          {{ viewRegisterButtonText }}
        </span>

			</a>
		</td>
	</tr>
</template>

<script>
import moment from 'moment';

export default {
  name: 'Run',

  data() {
    return {};
  },
  props: ['run'],
  computed: {
    viewRegisterButtonText() {
      if (this.hasNoSpacesAvailable) {
        return 'Join Waiting List';
      }
      return 'Info & Booking';
    },

    viewRegisterButtonTextMobile() {
      if (this.hasNoSpacesAvailable) {
        return 'Waiting List';
      }
      return 'Book';
    },

    hasNoSpacesAvailable() {
      return (
        parseInt(this.run.bookingsCount) >= parseInt(this.run.capacity)
      );
    },
    days() {
      let output = '';
      Object.values(this.run.sessions).forEach((session, index) => {
        output += `${session.day} <br /> `;
      });
      return output;
    },

    times() {
      let output = '';
      Object.values(this.run.sessions).forEach((session, index) => {
        output += `${session.startTime} - ${session.endTime}  <br />`;
      });
      return output;
    },
    dayWithTimes() {
      let output = '';
      Object.values(this.run.sessions).forEach((session, index) => {
        output += `<strong>${session.day}</strong><br /> ${session.startTime} - ${session.endTime}  <br />`;
      });
      return output;
    },
    runStartTime() {
      return moment.utc(this.run.runStartTime * 1000).format('h:mm a');
    },
    runEndTime() {
      return moment.utc(this.run.runEndTime * 1000).format('h:mm a');
    },

    viewRunInfoRoute() {
      return Routing.generate('PublicBookingBundle_run_info', {
        runId: this.run.runId,
      });
    },

    ageFrom() {
      return this.getClassAgeStringFromMonthsCount(this.run.ageFrom);
    },
    ageTo() {
      return this.getClassAgeStringFromMonthsCount(this.run.ageTo);
    },
    runHasTrialOptions() {
      return parseInt(this.run.hasTrialOptions) == 1;
    },
  },

  methods: {
    getClassAgeStringFromMonthsCount(months) {
      if (months < 24) {
        return `${months} mths`;
      } if (months % 12 == 0) {
        return `${months / 12}yrs`;
      }
      return (
        `${Math.floor(months / 12)
					 }yrs ${
					 months % 12
					 }${months > 1 ? 'mths' : 'mth'}`
      );
    },
  },

  mounted() {},
};
</script>

<style scoped></style>
